
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/amazonecs/thanks",
      function () {
        return require("private-next-pages/services/amazonecs/thanks.tsx");
      }
    ]);
  